<template lang="pug">
  .btn.group.fixedBottomRight(ref='btn', @click="$emit('click')")
    slot
</template>
<script>
import $ from 'jquery'
export default {
  mounted () {
    $(this.$refs.btn).on('touchstart mouseenter', function (e) {
      e.stopPropagation()
      setTimeout(() => {
        if ($(this).find('a').length > 0) {
          $(this).addClass('hover')
        }
      }, 100)
    }).on('mouseleave', function (e) {
      e.stopPropagation()
      return $(this).removeClass('hover')
    })
    $('body').on('touchstart.fixedBottomRight click.fixedBottomRight', (e) => {
      if (!$.contains(document.documentElement, e.target)) {
        return
      }
      if ($(e.target).closest(this.$refs.btn).length === 0) {
        return $(this.$refs.btn).removeClass('hover')
      }
    })
  },
  destroyed () {
    $('body').off('.fixedBottomRight')
  }
}
</script>



// WEBPACK FOOTER //
// FloatBtn.vue?57223fcf